<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .inputs {
    display: flex;
    width: 100%;
    flex-wrap: no-wrap;
    gap: utils.in_rem(8px);

    .input {
      width: calc(100% / 3 - 4px);
      display: flex;
      flex-direction: column;
      align-items: stretch;
    }
  }
</style>

<script>
  import Label from "@sourcewhale/shared/svelte-design-system/components/atoms/InputLabels/Label.svelte";
  import NumberInput from "@sourcewhale/shared/svelte-design-system/components/molecules/InputFields/NumberInput.svelte";
  import {
    additionsStore,
    modulePricingApiStore,
    priceSuffixStore,
  } from "../stores";

  let { mod, max = null } = $props();

  let price = $derived($modulePricingApiStore?.modules[mod.kind] || 0);
  let totalPrice = $derived($additionsStore[mod.kind] * price);
</script>

<div class="inputs">
  <div class="input">
    <Label label="Licenses" labelSize="small" />
    <NumberInput
      bind:value={$additionsStore[mod.kind]}
      min={1}
      {max}
      style="width:100%"
    />
  </div>

  <div class="input">
    <Label label="Price per License{$priceSuffixStore}" labelSize="small" />
    <NumberInput style="width:100%" value={price} disabled={true} />
  </div>
  <div class="input">
    <Label label="Total Price{$priceSuffixStore}" labelSize="small" />
    <NumberInput style="width:100%" value={totalPrice} disabled={true} />
  </div>
</div>
